module.exports = __webpack_public_path__ + "img/square-phone-hangup.e4022478.svg";